  document.addEventListener('DOMContentLoaded', function () {
    const policyContainer = document.querySelector('.shopify-policy__container');

    if (policyContainer) {
      policyContainer.classList.add(
        'section',
        'section--full-width-margin',
        'section--page-width'
      );
    }
  });